/**
 * Formatea un timestamp de BD (medianoche sin zona) como fecha calendario.
 * Usa UTC para evitar desfase de un día en zonas horarias negativas (ej. Argentina).
 * @param {Date|string|null|undefined} fecha
 * @param {string} [locale='es-ES']
 * @returns {string|null}
 */
export const formatDateOnly = (fecha, locale = 'es-ES') => {
   if (!fecha) return null;

   const date = fecha instanceof Date ? fecha : new Date(fecha);
   if (Number.isNaN(date.getTime())) return null;

   return date.toLocaleDateString(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
   });
};

/**
 * Calcula la edad en años a partir de una fecha de nacimiento
 * @param {Date|string|null} fechaNacimiento - Fecha de nacimiento (Date, string YYYY/MM/DD, o null)
 * @returns {number|null} - Edad en años o null si la fecha es inválida
 */
export const calcularEdad = (fechaNacimiento) => {
   if (!fechaNacimiento) return null;

   let fecha;
   if (fechaNacimiento instanceof Date) {
      if (isNaN(fechaNacimiento.getTime())) return null;
      fecha = fechaNacimiento;
   } else if (typeof fechaNacimiento === 'string') {
      // Parsear formato YYYY/MM/DD o YYYY-MM-DD
      const match = fechaNacimiento.match(/^(\d{4})[\/\-](\d{2})[\/\-](\d{2})$/);
      if (match) {
         const year = parseInt(match[1], 10);
         const month = parseInt(match[2], 10) - 1;
         const day = parseInt(match[3], 10);
         fecha = new Date(year, month, day);

         // Validar que la fecha sea válida
         if (
            fecha.getFullYear() !== year ||
            fecha.getMonth() !== month ||
            fecha.getDate() !== day
         ) {
            return null;
         }
      } else {
         // Intentar parsear como fecha ISO
         fecha = new Date(fechaNacimiento);
         if (isNaN(fecha.getTime())) return null;
      }
   } else {
      return null;
   }

   const hoy = new Date();
   let edad = hoy.getFullYear() - fecha.getFullYear();
   const mes = hoy.getMonth() - fecha.getMonth();

   // Ajustar si aún no cumplió años este año
   if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
      edad--;
   }

   return edad;
};
